import { createContext, useContext } from 'react';
import type { BoardKind } from '../utils/buyerBoardColumns';

/**
 * Which board the tables below draw: the buyer board (POs) or the transfer
 * board (TOs). Each keeps its own saved column views and defaults.
 */
// Where each board lives: the buyer board (POs) and the transfer board (TOs).
export const BOARD_PATHS = {
  po: '/procurement/replenishment',
  to: '/procurement/internal-transfers',
} as const satisfies Record<BoardKind, string>;

export const BoardKindContext = createContext<BoardKind>('po');

export function useBoardKind(): BoardKind {
  return useContext(BoardKindContext);
}
